import { alpha } from '@mui/material/styles';
import { mobileAppGlassCard } from '../components/layout/mobile/mobileAppTheme';
import { LOGIN_ACCENT } from '../components/auth/loginDarkTheme';

export const HOME_DASHBOARD_ACCENT = LOGIN_ACCENT;

export function getMobileHomeOverviewPanelSx() {
  return {
    ...mobileAppGlassCard,
    p: { xs: 0.65, sm: 0.6 },
    borderRadius: '14px',
    background:
      'linear-gradient(160deg, rgba(8, 12, 24, 0.92) 0%, rgba(3, 7, 18, 0.96) 55%, rgba(6, 16, 14, 0.88) 100%)',
    boxShadow:
      '0 14px 28px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -1px 0 rgba(76,225,182,0.05)',
  };
}

export function getMobileHomeSectionChipSx(accent = HOME_DASHBOARD_ACCENT) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.35,
    px: 0.55,
    py: 0.18,
    borderRadius: 999,
    bgcolor: alpha(accent, 0.1),
    border: `1px solid ${alpha(accent, 0.22)}`,
    color: alpha(accent, 0.95),
    fontSize: '0.56rem',
    fontWeight: 700,
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    lineHeight: 1,
  };
}

export function getMobileHomeSectionChipDotSx(accent = HOME_DASHBOARD_ACCENT) {
  return {
    width: 5,
    height: 5,
    borderRadius: '50%',
    bgcolor: accent,
    boxShadow: `0 0 6px ${alpha(accent, 0.55)}`,
  };
}

export function getMobileHomeMetricTileSx(accent = HOME_DASHBOARD_ACCENT) {
  return {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '12px',
    px: { xs: 0.65, sm: 0.6 },
    py: { xs: 0.65, sm: 0.6 },
    height: 68,
    maxHeight: 68,
    minHeight: 68,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: { xs: 0.5, sm: 0.45 },
    background: `linear-gradient(155deg, ${alpha('#ffffff', 0.05)} 0%, ${alpha('#000000', 0.22)} 100%)`,
    border: `1px solid ${alpha('#ffffff', 0.08)}`,
    boxShadow: `inset 0 1px 0 ${alpha('#ffffff', 0.04)}`,
  };
}

export function getMobileHomeMetricIconSx(accent = HOME_DASHBOARD_ACCENT) {
  return {
    width: { xs: 32, sm: 30 },
    height: { xs: 32, sm: 30 },
    borderRadius: '9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: `linear-gradient(145deg, ${alpha(accent, 0.3)} 0%, ${alpha(accent, 0.08)} 100%)`,
    border: `1px solid ${alpha(accent, 0.24)}`,
    color: accent,
    boxShadow: `0 4px 10px ${alpha(accent, 0.12)}`,
    '& .MuiSvgIcon-root': {
      fontSize: { xs: 17, sm: 16 },
    },
  };
}

export function getMobileHomeMetricContentSx() {
  return {
    minWidth: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: 0.1,
  };
}

export function getMobileHomeMetricValueSx() {
  return {
    color: '#f8fafc',
    fontWeight: 800,
    fontSize: 'clamp(0.92rem, 3.8vw, 1.14rem)',
    lineHeight: 1.15,
    letterSpacing: '-0.02em',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    width: '100%',
  };
}

export function getMobileHomeMetricLabelSx() {
  return {
    color: alpha('#94a3b8', 0.95),
    fontSize: '0.48rem',
    fontWeight: 600,
    lineHeight: 1.1,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    width: '100%',
  };
}

export function getMobileHomeDatePillSx() {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    px: 0.75,
    py: 0.28,
    borderRadius: 999,
    bgcolor: alpha('#ffffff', 0.05),
    border: `1px solid ${alpha('#ffffff', 0.08)}`,
    color: alpha('#cbd5e1', 0.95),
    fontSize: '0.66rem',
    fontWeight: 600,
    letterSpacing: '0.01em',
  };
}

export function getMobileHomeDividerSx() {
  return {
    my: 0.45,
    height: '1px',
    background: `linear-gradient(90deg, transparent 0%, ${alpha('#ffffff', 0.12)} 50%, transparent 100%)`,
  };
}

export function getMobileHomeMetricGridSpacing() {
  return 0.5;
}

export function getMobileHomeMetricGridSx() {
  return {
    mt: 0.4,
    alignItems: 'flex-start',
  };
}

export function getMobileHomeInventoryPanelSx() {
  return {
    ...mobileAppGlassCard,
    p: { xs: 0.65, sm: 0.6 },
    borderRadius: '14px',
    background:
      'linear-gradient(160deg, rgba(8, 12, 24, 0.92) 0%, rgba(3, 7, 18, 0.96) 100%)',
  };
}

export function getMobileHomeInventoryBarTrackSx() {
  return {
    display: 'flex',
    gap: 0.4,
    height: 12,
    borderRadius: 999,
    p: 0.3,
    bgcolor: alpha('#000000', 0.35),
    border: `1px solid ${alpha('#ffffff', 0.06)}`,
    mb: 0.55,
  };
}

export function getMobileHomeInventoryBarSegmentSx(color, widthPercent) {
  return {
    width: `${widthPercent}%`,
    minWidth: widthPercent > 0 ? 6 : 0,
    borderRadius: 999,
    bgcolor: color,
    boxShadow: `0 0 10px ${alpha(color, 0.35)}`,
    transition: 'width 0.4s ease',
  };
}

export function getMobileHomeInventoryChipSx(color) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 0.45,
    px: 0.5,
    py: 0.32,
    borderRadius: '9px',
    minWidth: 0,
    flex: '1 1 0',
    background: `linear-gradient(145deg, ${alpha(color, 0.16)} 0%, ${alpha('#000000', 0.2)} 100%)`,
    border: `1px solid ${alpha(color, 0.28)}`,
  };
}

export function getMobileHomeInventoryChipValueSx() {
  return {
    color: '#f8fafc',
    fontSize: '0.82rem',
    fontWeight: 800,
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
  };
}

export function getMobileHomeInventoryChipLabelSx() {
  return {
    color: alpha('#94a3b8', 0.95),
    fontSize: '0.54rem',
    fontWeight: 600,
    lineHeight: 1.1,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
  };
}

export function getMobileHomeViewAllSx(accent = HOME_DASHBOARD_ACCENT) {
  return {
    color: accent,
    fontSize: '0.78rem',
    fontWeight: 700,
    textDecoration: 'none',
    px: 0.85,
    py: 0.35,
    borderRadius: 999,
    bgcolor: alpha(accent, 0.1),
    border: `1px solid ${alpha(accent, 0.2)}`,
    transition: 'background-color 0.15s ease',
    '&:active': {
      bgcolor: alpha(accent, 0.18),
    },
  };
}

export function getMobileHomeQuickActionSx(accent) {
  return {
    ...mobileAppGlassCard,
    p: 0.6,
    minHeight: 54,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.45,
    cursor: 'pointer',
    borderRadius: '12px',
    transition: 'transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease',
    '&:active': {
      transform: 'scale(0.97)',
      borderColor: alpha(accent || HOME_DASHBOARD_ACCENT, 0.35),
    },
  };
}

export function getMobileHomeQuickActionIconSx(color, isMore = false) {
  return {
    width: 30,
    height: 30,
    borderRadius: '9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: isMore
      ? `linear-gradient(145deg, ${alpha('#94a3b8', 0.18)} 0%, ${alpha('#000000', 0.2)} 100%)`
      : `linear-gradient(145deg, ${alpha(color, 0.32)} 0%, ${alpha(color, 0.1)} 100%)`,
    border: `1px solid ${isMore ? alpha('#94a3b8', 0.2) : alpha(color, 0.28)}`,
    color: isMore ? '#cbd5e1' : color,
    boxShadow: isMore ? 'none' : `0 6px 14px ${alpha(color, 0.16)}`,
  };
}
